
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./advanced-3-tooling-and-ecosystem.json") })
        }
      }, "path---advanced-3-tooling-and-ecosystem");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---advanced-3-tooling-and-ecosystem!./.cache/json/advanced-3-tooling-and-ecosystem.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---advanced-3-tooling-and-ecosystem!./.cache/json/advanced-3-tooling-and-ecosystem.json
// module chunks = 154